(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pricing-boussole"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Smooth-scroll interceptor for #services links — bulletproof,
    // works regardless of how Shopify wraps sections.
    if (window.__bslHashInit) return;
    window.__bslHashInit = true;

    function scrollToPricing(behavior) {
      var anchor = document.getElementById('services');
      var target = anchor || document.querySelector('.bsl-pricing');
      if (!target) return false;
      var y = target.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: behavior || 'smooth' });
      return true;
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href === '#services' || /(^|\/)([^#]*)#services$/.test(href)) {
        if (scrollToPricing('smooth')) {
          e.preventDefault();
          if (history.replaceState) history.replaceState(null, '', '#services');
        }
      }
    }, false);

    if (location.hash === '#services') {
      window.addEventListener('load', function () {
        setTimeout(function () { scrollToPricing('auto'); }, 50);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-program-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Scope: every Sticky Program section on the page is initialized independently.
    var sections = document.querySelectorAll('.bsl-prog');
    if (!sections.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      var reveals = section.querySelectorAll('[data-bsl-reveal]');
      var media = section.querySelector('[data-bsl-media]');
      var rail = section.querySelector('[data-bsl-rail]');
      var parallaxEnabled = section.dataset.parallax === 'true' && !prefersReduced;

      // 1) Reveal-on-scroll for feature blocks
      if ('IntersectionObserver' in window && !prefersReduced) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

        reveals.forEach(function (el) { io.observe(el); });
      } else {
        // Fallback: just show everything
        reveals.forEach(function (el) { el.classList.add('is-visible'); });
      }

      // 2) Scroll progress rail + optional subtle parallax scale
      if (!rail && !parallaxEnabled) return;

      var ticking = false;
      function update() {
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        // progress: 0 when section enters viewport, 1 when bottom leaves
        var total = rect.height + vh;
        var passed = vh - rect.top;
        var p = Math.max(0, Math.min(1, passed / total));

        if (rail) rail.style.height = (p * 100) + '%';

        if (parallaxEnabled && media) {
          // very subtle scale 1.00 -> 1.04 across the section
          var scale = 1 + (p * 0.04);
          media.style.transform = 'scale(' + scale.toFixed(4) + ')';
        }
        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
